import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BscConnector } from '@binance-chain/bsc-connector';
import { useWeb3React } from '@web3-react/core';
import { InjectedConnector } from '@web3-react/injected-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { createContext, useCallback, useContext, useEffect, useMemo, useReducer } from 'react';
import * as React from 'react';
import { ConnectWalletDialog } from '../../components/Dialogs/ConnectWalletDialog';
var walletconnect = new WalletConnectConnector({
  supportedChainIds: [1, 56, 97, 137, 43114, 250],
  rpc: {
    1: 'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    56: 'https://bsc-dataseed.binance.org/',
    137: 'https://rpc-mainnet.matic.network',
    43114: 'https://api.avax.network/ext/bc/C/rpc',
    250: 'https://rpc.ftm.tools'
  },
  qrcode: true,
  bridge: 'https://bridge.walletconnect.org',
  pollingInterval: 15000
});
var injected = new InjectedConnector({
  supportedChainIds: [1, 56, 97, 137, 43114, 250]
});
var bscConnector = new BscConnector({
  supportedChainIds: [1, 56, 137, 43114, 250]
}); //TODO remove watch and terra for move to new page (profile page)

var shareInitialState = {
  connectorId: null
};
var AccountContext = /*#__PURE__*/createContext(_objectSpread({
  onConnect: function onConnect() {
    return null;
  },
  disconnect: function disconnect() {
    return null;
  }
}, shareInitialState));
export var useAccountContext = function useAccountContext() {
  var ctx = useContext(AccountContext);
  if (ctx === undefined) throw new Error('useAccountContext hook must be used within a AccountProvider');
  return ctx;
};

var initialState = _objectSpread({
  visibleConnect: false
}, shareInitialState);

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'visibleConnect':
      return _objectSpread(_objectSpread({}, state), {}, {
        visibleConnect: !state.visibleConnect
      });

    case 'connectorId':
      return _objectSpread(_objectSpread({}, state), {}, {
        connectorId: action.payload,
        visibleConnect: false
      });

    case 'disconnect':
      return _objectSpread(_objectSpread({}, state), {}, {
        connectorId: null,
        visibleConnect: false
      });

    case 'persist':
      return _objectSpread(_objectSpread({}, state), {}, {
        connectorId: action.payload.connectorId
      });

    default:
      return state;
  }
};

export var AccountProvider = function AccountProvider(_ref) {
  var children = _ref.children;

  var _useReducer = useReducer(reducer, initialState),
      _useReducer$ = _useReducer[0],
      visibleConnect = _useReducer$.visibleConnect,
      connectorId = _useReducer$.connectorId,
      dispatch = _useReducer[1];

  var _useWeb3React = useWeb3React(),
      activate = _useWeb3React.activate,
      deactivate = _useWeb3React.deactivate;

  useEffect(function () {
    var _ref2;

    var selectedConnectorId = (_ref2 = localStorage.getItem('connectorId')) !== null && _ref2 !== void 0 ? _ref2 : 'none';

    function activateWallet() {
      return _activateWallet.apply(this, arguments);
    }

    function _activateWallet() {
      _activateWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var ethereum;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (['none', 'walletconnect'].includes(selectedConnectorId)) {
                  _context.next = 16;
                  break;
                }

                if (!['metamask', 'safe-pal', 'trust-wallet'].includes(selectedConnectorId)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return activate(injected);

              case 5:
                _context.next = 14;
                break;

              case 7:
                if (!(selectedConnectorId === 'walletconnect')) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return activate(walletconnect);

              case 10:
                _context.next = 14;
                break;

              case 12:
                _context.next = 14;
                return activate(bscConnector);

              case 14:
                ethereum = window.ethereum;
                ethereum.removeAllListeners(['networkChanged']);

              case 16:
                dispatch({
                  type: 'persist',
                  payload: {
                    connectorId: selectedConnectorId
                  }
                });
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 19]]);
      }));
      return _activateWallet.apply(this, arguments);
    }

    activateWallet(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); //? Connect

  var handleConnect = function handleConnect(selectedConnectorId) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var ethereum;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(selectedConnectorId !== 'none')) {
                _context2.next = 15;
                break;
              }

              if (!['metamask', 'safe-pal', 'trust-wallet'].includes(selectedConnectorId)) {
                _context2.next = 6;
                break;
              }

              _context2.next = 4;
              return activate(injected);

            case 4:
              _context2.next = 13;
              break;

            case 6:
              if (!(selectedConnectorId === 'walletconnect')) {
                _context2.next = 11;
                break;
              }

              _context2.next = 9;
              return activate(walletconnect);

            case 9:
              _context2.next = 13;
              break;

            case 11:
              _context2.next = 13;
              return activate(bscConnector);

            case 13:
              ethereum = window.ethereum;
              ethereum.removeAllListeners(['networkChanged']);

            case 15:
              localStorage.setItem('connectorId', selectedConnectorId);
              dispatch({
                type: 'connectorId',
                payload: selectedConnectorId
              });

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };

  var handleVisibleConnect = function handleVisibleConnect() {
    dispatch({
      type: 'visibleConnect'
    });
  };

  var disconnect = useCallback(function () {
    localStorage.removeItem('connectorId');
    deactivate();
    dispatch({
      type: 'disconnect'
    });
  }, [deactivate]);
  var ctx = useMemo(function () {
    return {
      onConnect: handleVisibleConnect,
      disconnect: disconnect,
      connectorId: connectorId
    };
  }, [connectorId, disconnect]);
  return _jsxs(AccountContext.Provider, {
    value: ctx,
    children: [children, _jsx(ConnectWalletDialog, {
      open: visibleConnect,
      onClose: handleVisibleConnect,
      handleConnect: handleConnect
    })]
  });
};